<!-- Footer -->
<footer class="footer-bg text-center py-3 mt-4 border-top">
  <b>Gobierno del Estado de Tlaxcala</b>
  <br>
  © <b>{{ currentYear }}</b> | Secretaría de Finanzas | Informática Financiera.
</footer>
